const sensitiveKeys = new Set([
  "password",
  "passwordconfirmation",
  "passwordresetcode",
  "signupconfirmationcode",
  "authorization",
  "cookie",
  "set-cookie",
  "token",
  "accesstoken",
  "fcmtoken",
  "code",
  "csrftoken",
  "x-tirss-csrf",
]);
const sensitiveUrlQueryPattern = new RegExp(
  `([?&](?:${[...sensitiveKeys].join("|")})=)[^&#\\s]*`,
  "gi"
);

/** Sanitize authentication credentials before error, trace or replay events leave the browser. */
export function redactAuthentication<T>(value: T): T;
export function redactAuthentication(value: unknown): unknown {
  if (typeof value === "string") {
    return value.replace(sensitiveUrlQueryPattern, "$1REDACTED");
  }
  if (Array.isArray(value)) return value.map((entry) => redactAuthentication(entry));
  if (!value || typeof value !== "object") return value;

  return Object.fromEntries(
    Object.entries(value).map(([key, entry]) => [
      key,
      sensitiveKeys.has(key.toLowerCase()) ? "REDACTED" : redactAuthentication(entry),
    ])
  );
}
